// extracted by mini-css-extract-plugin
export var outcomeIcon = "PickIcon-module--outcomeIcon--539cc";